import React from 'react';
import { PRODUCTS } from '../config/columns.config';
import { formatMoney } from '../utils/formatters';
import { useTheme, alpha } from '@mui/material/styles';

const SummaryTable = ({ rows, config }) => {
  const theme = useTheme();
  const isSales = config?.reportCategory === 'sales';

  return (
    <table className="w-full text-sm border-collapse table-fixed">
      <colgroup>
        <col className="w-64" />
        {PRODUCTS.map(p => <col key={p.key} className="w-24" />)}
        <col className="w-24" />
        {isSales && (
          <>
            <col className="w-24" />
            <col className="w-24" />
            <col className="w-24" />
          </>
        )}
      </colgroup>
      <tbody>
        {rows.map(row => {
          const isTotalRow = row.label.toLowerCase().includes('total');
          const rowClass = isTotalRow
            ? "font-bold border-b"
            : "border-b";

          return (
            <tr 
              key={row.id} 
              className={rowClass}
              style={isTotalRow ? {
                backgroundColor: alpha(theme.palette.text.primary, 0.12),
                borderColor: theme.palette.divider
              } : {
                backgroundColor: theme.palette.background.paper,
                borderColor: theme.palette.divider
              }}
            >
              <td 
                className="p-4 font-medium truncate"
                style={{ color: isTotalRow ? theme.palette.text.primary : theme.palette.text.secondary }}
              >
                {row.label}
              </td>

              {PRODUCTS.map(p => (
                <td 
                  key={p.key} 
                  className="p-4 text-right truncate"
                  style={{ color: isTotalRow ? theme.palette.warning.main : theme.palette.text.secondary }}
                >
                  {formatMoney(row.values[p.key] || 0)}
                </td>
              ))}

              <td 
                className="p-4 text-right font-semibold truncate"
                style={{ color: isTotalRow ? theme.palette.warning.main : theme.palette.text.primary }}
              >
                {formatMoney(row.total)}
              </td>

              {isSales && (
                <>
                  <td 
                    className="p-4 text-right truncate"
                    style={{ color: isTotalRow ? theme.palette.warning.main : theme.palette.text.secondary }}
                  >
                    {formatMoney(row.budget)}
                  </td>
                  <td 
                    className="p-4 text-right truncate"
                    style={{ color: isTotalRow ? theme.palette.warning.main : theme.palette.text.secondary }}
                  >
                    {row.percentageAchieved.toFixed(2)} %
                  </td>
                  <td 
                    className="p-4 text-right truncate"
                    style={{ color: isTotalRow ? theme.palette.warning.main : theme.palette.text.secondary }}
                  >
                    {row.proRataAchieved.toFixed(2)} %
                  </td>
                </>
              )}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default SummaryTable;